import { useTheme} from '@mui/material';
import { makeStyles } from '@mui/styles'

export const useStyles = makeStyles((theme)=>({

    list:{
        display: 'flex',
        flexDirection: 'column'
    },
    buttonList: {
        width: '100% !important',
        padding: '16px',
        gap: '16px',
        minHeight: '56px',
        background: '#FCFCFC',
        border: '1px solid #F2F2F2',
        borderRadius: '8px',
        marginTop: '16px',
        '&:focus': {
          outline: 'none !important',
        },
        '&:hover': {
          outline: 'none !important',
        },
      },
}))